import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import moment from 'moment';
import { Photo } from '../Photo';
import './Area.scss';
import { AlbumType } from '../../../../../types/models';
import { CLOUDFRONT_URL, S3_BUCKET_URL } from '../../../../../core/common';
import useModal from '../../../../../hooks/useModal';
import MetadataModal from '../MetadataModal/MetadataModal';
import Partners from '../Partners';
import { apiAlbumAccept, apiAlbumDecline, apiAlbumHold } from '../../../../../actions/photoActions';

export const Area = ({ album }: { album: AlbumType }) => {
  const [currentAlbum, setCurrentAlbum] = useState<AlbumType>(album);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState<Set<number>>(new Set());

  const [metadataModalOpen, openMetadataModal, closeMetadataModal, metadataModalObj] = useModal();

  const handlePhotoClick = (index: number) => {
    setSelectedIndex(index);
    setIsLightboxOpen(true);
  };

  const handleMetadataClick = (index: number) => {
    openMetadataModal({
      metadata: currentAlbum.photos[index].metadata,
      photoId: currentAlbum.photos[index].id,
    });
  };

  const handlePhotoSelect = (index: number, selected: boolean) => {
    const newSelected = new Set(selectedPhotos);
    if (selected) {
      newSelected.add(index);
    } else {
      newSelected.delete(index);
    }
    setSelectedPhotos(newSelected);
  };

  const handleDeleteSelected = () => {
    const selectedIds = Array.from(selectedPhotos).map(index => currentAlbum.photos[index].id);
    console.log('Delete selected photos with IDs:', selectedIds);
    // Здесь будет логика удаления
  };

  const handleMoveSelected = () => {
    const selectedIds = Array.from(selectedPhotos).map(index => currentAlbum.photos[index].id);
    console.log('Move selected photos with IDs:', selectedIds);
    // Здесь будет логика перемещения
  };

  const handleSelectAll = () => {
    if (selectedPhotos.size === currentAlbum.photos.length) {
      setSelectedPhotos(new Set());
    } else {
      setSelectedPhotos(new Set(currentAlbum.photos.map((_, index) => index)));
    }
  };

  const handleAccept = () => {
    console.log('Accept album:', currentAlbum.id);
    apiAlbumAccept(currentAlbum.id).then(status => {
      if (status) {
        setCurrentAlbum(prev => ({ ...prev, status: 2 }));
      }
    });
  };

  const handleDecline = () => {
    console.log('Decline album:', currentAlbum.id);
    apiAlbumDecline(currentAlbum.id).then(status => {
      if (status) {
        setCurrentAlbum(prev => ({ ...prev, status: 0 }));
      }
    });
  };

  const handleOnHold = () => {
    console.log('On hold album:', currentAlbum.id);
    apiAlbumHold(currentAlbum.id).then(status => {
      if (status) {
        setCurrentAlbum(prev => ({ ...prev, status: 3 }));
      }
    });
  };

  const handleMetadataUpdate = (photoId: number, newMetadata: any) => {
    setCurrentAlbum(prev => ({
      ...prev,
      photos: prev.photos.map(photo =>
        photo.id === photoId ? { ...photo, metadata: newMetadata } : photo
      ),
    }));
  };

  return (
    <>
      <MetadataModal
        open={metadataModalOpen}
        onClose={closeMetadataModal}
        metadata={metadataModalObj?.metadata || {}}
        photoId={metadataModalObj?.photoId || 0}
        onMetadataUpdate={handleMetadataUpdate}
      />
      <div className="pf-area">
        <div className="pf-area-header" onClick={() => setOpen(!open)}>
          <div className="pf-area-header-info">
            <div className="pf-area-header-id">ID: {currentAlbum.id}</div>
            <div className="pf-area-header-title">
              <span>{currentAlbum.title}</span>
              <span className="pf-area-header-subtitle">{currentAlbum.name}</span>
            </div>
          </div>
          <div className="pf-area-header-meta">
            <div className="pf-area-header-status">
              {currentAlbum.status === 2 && <span className="status-approved">Approved</span>}
              {currentAlbum.status === 0 && <span className="status-declined">Declined</span>}
              {currentAlbum.status === 1 && (
                <span className="status-moderation">On moderation</span>
              )}
              {currentAlbum.status === 3 && <span className="status-hold">On hold</span>}
            </div>
            <div className="pf-area-header-created">
              Created: {moment(currentAlbum.created_at).format('DD/MM/YYYY HH:mm')}
            </div>
            <div className="pf-area-header-uploader">By: MEI</div>
          </div>
          <i
            className={`pf-area-header-arrow fa ${open ? 'fa-chevron-up' : 'fa-chevron-down'}`}
            aria-hidden="true"
          />
        </div>
        {open && (
          <div className="pf-area-content">
            <div className="pf-area-photos-section">
              <div className="pf-area-actions">
                <button className="pf-area-select-all-btn" onClick={handleSelectAll}>
                  {selectedPhotos.size === currentAlbum.photos.length
                    ? 'Deselect All'
                    : 'Select All'}
                </button>
                {selectedPhotos.size > 0 && (
                  <>
                    <button className="pf-area-move-btn" onClick={handleMoveSelected}>
                      Move Selected ({selectedPhotos.size})
                    </button>
                    <button className="pf-area-delete-btn" onClick={handleDeleteSelected}>
                      Delete Selected ({selectedPhotos.size})
                    </button>
                  </>
                )}
              </div>

              <div className="pf-area-photos">
                {currentAlbum.photos.map((photo, index) => (
                  <Photo
                    key={index}
                    src={`${CLOUDFRONT_URL}${photo.thumbnail_path}`}
                    title={photo.filename}
                    onPhotoClick={() => handlePhotoClick(index)}
                    onMetadataClick={() => handleMetadataClick(index)}
                    isSelected={selectedPhotos.has(index)}
                    onSelectChange={selected => handlePhotoSelect(index, selected)}
                    downloadUrl={`${S3_BUCKET_URL}/${photo.path}`}
                  />
                ))}
              </div>
            </div>
            <div className="pf-area-sidebar">
              <div className="pf-area-status-buttons">
                {currentAlbum.status !== 2 && (
                  <button className="pf-area-accept-btn" onClick={handleAccept}>
                    Accept
                  </button>
                )}
                {currentAlbum.status !== 0 && (
                  <button className="pf-area-decline-btn" onClick={handleDecline}>
                    Decline
                  </button>
                )}
                {currentAlbum.status !== 3 && (
                  <button className="pf-area-hold-btn" onClick={handleOnHold}>
                    On hold
                  </button>
                )}
              </div>
              <Partners albumId={currentAlbum.id} />
            </div>
          </div>
        )}
      </div>
      <Lightbox
        open={isLightboxOpen}
        close={() => setIsLightboxOpen(false)}
        index={selectedIndex}
        slides={currentAlbum.photos.map(photo => ({
          src: `${CLOUDFRONT_URL}${photo.path}`,
          title: photo.filename,
        }))}
        carousel={{
          finite: true,
          preload: 2,
        }}
        animation={{
          fade: 300,
          swipe: 500,
        }}
        controller={{
          closeOnBackdropClick: true,
          closeOnPullDown: true,
        }}
      />
    </>
  );
};
